'use client';

import Navbar from '@/components/Navbar';

export default function AnalyzeLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
        {children}
      </main>
    </>
  );
}
